import React from 'react';

export default function Summary() {
    return (
        <section id="summary" className="mb-12 px-4 sm:px-6 lg:px-8">
            <h2 className="text-2xl sm:text-3xl font-bold mb-6 pb-2 border-b-2 border-blue-500">PROFESSIONAL SUMMARY</h2>
            <p className="text-lg sm:text-base">
                Outgoing M.Tech in Computer Science and Engineering from IIT Hyderabad, eager to leverage my knowledge and passion for technology in impactful projects that drive innovation and contribute to my professional growth in the field of computer science and cybersecurity.
            </p>
        </section>
    );
}
